import type {
  ReactNode,
  MouseEventHandler,
  DetailedHTMLProps,
  ButtonHTMLAttributes,
} from 'react';
import classNames from 'classnames';
import {
  CircleNotchIcon,
} from '@/ui/icons';

import styles from './Button.module.css';

type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  kind?: 'default' | 'outline' | 'clear' | 'ghost' | 'link';
  color?: 'dark' | 'primary' | 'secondary' | 'danger';
  type?: 'button' | 'submit';
  centered?: boolean;
  roundness?: 'round' | 'rounded' | 'inherit';
  loading?: boolean;
  children?: ReactNode;
  onClick?: MouseEventHandler;
}

const Button = (props: ButtonProps) => {
  const {
    ref,
    kind = 'default',
    type = 'button',
    color = 'primary',
    children,
    roundness,
    centered = false,
    loading = false,
    className,
    ...rest
  } = props;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const buttonClassName = classNames({
    [styles.button]: true,
    [styles[kind]]: !!kind,
    [styles[color]]: !!color,
    [styles[roundness]]: !!roundness,
    [styles.centered]: centered,
    [styles.loading]: loading,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      className={buttonClassName}
    >
      {loading && (
        <div className={styles.loader}>
          <CircleNotchIcon />
        </div>
      )}

      {!loading && children}
    </button>
  );
};

export default Button;
export type { ButtonProps };
